<footer class="footer">
  <div>&copy; 2018-{{ currentYear }} Chapwood Investments. All rights reserved.</div>
  <div>Maintained by <a href="https://sigmatechnicalgroup.com" target="_blank">Sigma Technical Group</a>.</div>
  <div>Build: {{ version }}</div>
</footer>